import PageResult from "../PageResult";

import { alertUser } from 'logic/eventBeforeunload';

import error from '../../../assets/icons/figma/icon-error.svg'

export default function PageSessionExpired() {

  const handleClickButton = () => {
    window.removeEventListener('beforeunload', alertUser);
    window.location.reload();
  }
  
  return (
    <PageResult
      header='ยืนยันตัวตน e-KYC'
      icon={error}
      titleText='หมดเวลาทำรายการ'
      des='กรุณายืนยันตัวตนใหม่อีกครั้ง'
      buttonText='กลับไปเริ่มยืนยันตัวตนใหม่'
      onClick={handleClickButton}
    />
  )
}
